import { render, staticRenderFns } from "./ccbUnionConfigure.vue?vue&type=template&id=3240e043&scoped=true"
import script from "./ccbUnionConfigure.vue?vue&type=script&lang=js"
export * from "./ccbUnionConfigure.vue?vue&type=script&lang=js"
import style0 from "./ccbUnionConfigure.vue?vue&type=style&index=0&id=3240e043&prod&scoped=true&lang=css"
import style1 from "./ccbUnionConfigure.vue?vue&type=style&index=1&id=3240e043&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3240e043",
  null
  
)

export default component.exports